import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { motion } from "framer-motion";
import InfiniteScroll from "react-infinite-scroll-component";
import styles from "../Dashboard.module.scss";
import { useStaffTaskList } from "repositories/task-management-repository";
import StaffTaskCard from "./StaffTaskCard";
import useStaffTaskModule from "accountOwner/pages/TaskManagement/hooks/useStaffTaskModule";
import NotAccessible from "../components/NotAccessible";
import { LoaderIcon } from "react-hot-toast";
import DashboardComment from "./DashboardComment";

const animationVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const StaffTasks = ({
  t,
  isArchive,
  appliedOfficeFilters,
  appliedStaffFilters,
  handleRedirect,
  isSchedulerOnly,
  showDetail,
  setShowDetail,
}) => {
  const {
    isLoading,
    tasks,
    pageNumber,
    totalPages,
    setPageNumber,
    setAppliedOfficeFilters,
    setAppliedAssignorFilter,
    handleActiontask,
    handleArchiveApi,
    refetch,
  } = useStaffTaskModule(useStaffTaskList, isArchive);

  const [selectedTask, setSelectedTask] = useState(null);

  let items = (
    <>
      {!showDetail ? (
        <>
          {tasks?.map((task) => (
            <StaffTaskCard
              myTask={task}
              key={task.id}
              handleRedirect={handleRedirect}
              handleActiontask={handleActiontask}
              handleArchiveApi={handleArchiveApi}
              isArchive={isArchive}
              onHeadingClick={(e) => {
                if (e.target.closest(".interactive-element")) {
                  return;
                }
                setSelectedTask(task);
                setShowDetail(true);
              }}
            />
          ))}
        </>
      ) : (
        <DashboardComment
          t={t}
          myTask={selectedTask}
          onHeadingClick={() => {
            refetch();
            setShowDetail(false);
          }}
        />
      )}
    </>
  );

  useEffect(() => {
    if (!isSchedulerOnly) {
      setAppliedOfficeFilters(appliedOfficeFilters);
      setAppliedAssignorFilter(appliedStaffFilters);
      setPageNumber(1);
    }
  }, [appliedOfficeFilters, appliedStaffFilters, isSchedulerOnly]);

  return (
    <>
      {!showDetail && isLoading && pageNumber === 1 ? (
        <LoaderIcon className={styles.loader_style} />
      ) : (
        <>
          {!tasks.length ? (
            <div
              className={
                styles["not_found"] +
                " " +
                "d-flex justify-content-center align-items-center"
              }
            >
              <NotAccessible
                isNotFound={true}
                Message={t("taskManagement.taskNotFound")}
              />
            </div>
          ) : (
            <motion.div
              variants={animationVariants}
              initial="hidden"
              animate="show"
              className="w-100"
            >
              <InfiniteScroll
                dataLength={tasks.length}
                hasMore={!showDetail && pageNumber < totalPages}
                loader={<LoaderIcon className={styles.loader_style} />}
                next={() => {
                  pageNumber < totalPages && setPageNumber((prev) => prev + 1);
                }}
                scrollableTarget="scrollableDivTwo"
              >
                {items}
              </InfiniteScroll>
            </motion.div>
          )}
        </>
      )}
    </>
  );
};
export default withTranslation()(StaffTasks);
